import { ENVIRONMENT } from "@/config/config";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import counterReducer from "@/features/counter/counterSlice";
import errorReducer from "@/features/error/errorSlice";
import loaderReducer from "@/features/loader/loaderSlice";
import metadataSlice from "@/features/metadata/metadataSlice";
import storage from "./storage";
import tokenSlice from "@/features/token/tokenSlice";
import quoteSlice from "@/features/quote/quoteSlice";
import proposalSlice from "@/features/proposal/proposalSlice";
import logger from "@/helpers/logger";
import quoteSlicePa from "@/features/quote-pa/quotePaSlice";
import proposalSlicePa from "@/features/proposal-pa/proposalPASlice";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["loader", "error", "counter"],
};
const appReducer = combineReducers({
  counter: counterReducer,
  error: errorReducer,
  loader: loaderReducer,
  metadata: metadataSlice,
  token: tokenSlice,
  quote: quoteSlice,
  proposal: proposalSlice,
  quotePa: quoteSlicePa,
  proposalPa: proposalSlicePa,
});

const rootReducer = (state, action) => {
  // Used to clear the persisted store data on a specific action.
  // Reference: https://bionicjulia.com/blog/clear-redux-toolkit-state-with-redux-persist-and-typescript
  if (action.type === "error/removeReduxData") {
    logger.log("RESETING...");
    storage.removeItem("persis:root");
    storage.removeItem("accessToken");
    storage.removeItem("accessTimestampExpiry");
    state = {};
  }
  // Set the loader to false. For special scenario, where loader was persisted as
  // true into the storage causing Loader to run endlessly. Ideally this will never happen
  // if (state) state.loader = false;
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: ENVIRONMENT !== "production",
  middleware: [thunk],
});

export const persistor = persistStore(store);
